<br>
<div class="col-lg-11 me-4 ms-4">
  <form [formGroup]="mailform">
    <div class="row">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-10" style="min-width:700px;">
        <mat-expansion-panel [expanded]=true>
          <mat-expansion-panel-header [expandedHeight]="'48px'">
            <mat-panel-title>
              Skicka mail
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="row">
            <div class="form-group col-md-8">
              <label for="to">
                Till
              </label>
              <input type="text" class="form-control form-control-sm" id="to" formControlName="to" required>
              <button class="btn mt-2" (click)="copyText()">Kopiera adresser</button>
            </div>
            <div class="form-group col-md-4">
              <label for="members">Maillista</label>
              <select class="form-control form-control-sm" id="country">
                <option></option>
                <option *ngFor="let m of memberlist" [ngValue]="m.id" [ngClass]="m.email1 ? '' : 'red'">{{m.givenName}}
                  {{m.familyName}}</option>
              </select>
              <span *ngIf="nomailcount > 0" class="red">{{nomailcount}} saknar epost</span>
            </div>
          </div>
          <div class="form-group">
            <label for="from">
              Från
            </label>
            <input type="text" class="form-control form-control-sm" id="from" formControlName="from" readonly>
          </div>
          <div class="form-group">
            <label for="to">
              Ämne
            </label>
            <input type="text" class="form-control form-control-sm" id="subject" formControlName="subject" required>
          </div>
          <div class="form-group">
            <label for="to">
              Meddelande
            </label>
            <p-editor class="notranslate" formControlName="msg" [style]="{'height':'320px'}"></p-editor>
          </div>
          <div class="row">
            <div class="col-md-8">
              <div class="form-group" style="margin-top:20px;">
                <div>Bilagor</div>
                <div>
                  <input type="file" id="file" (change)="fileProgress($event);" multiple />
                  <label for="file">Välj fil/filer</label>
                </div>
                <div *ngFor="let b of attachments" class="d-flex justify-content-start gap-3">
                  <div>{{b.name}} {{b.size/1000}} Kb</div> 
                  <div><i class="fa fa-trash" title="Radera bilaga {{b.name}}" (click)="removeAttachment(b)"></i></div>
                </div>
              </div>
              <div class="col-md-6" style="margin-top:20px;">
                <div class="d-flex justify-content-between">
                  <button class="btn border" (click)="postEmail()" [disabled]="!mailform.valid">Skicka</button>
                  <button class="btn border" (click)="cancel()" style="margin-left:10px;">Avbryt</button>
                </div>
              </div>
            </div>
            <!--div class="col-md-3" ondrop="drop(event)" ondragover="allowDrop(event)" style="border:2px dashed lightgrey;border-radius:5px;text-align: center;vertical-align: middle;opacity:0.5;background-color:#F0F0F0;line-height:50px;margin-right:5px;">
            Droppa filer (ej implementerat)
          </div-->
          </div>
        </mat-expansion-panel>
      </div>
    </div>
  </form>
</div>